import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { phaseChange, reroute, storeDumpItForce } from '../../../../actions/Buy'

class ThanksFirma extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 160 })

    if (this.props.customer && this.props.customer.token) {
      this.props.storeDumpItForce()
    }
  }

  render() {
    const { product } = this.props

    return (
      <div id={'thank-you-firma-completata'}>
        <div className={'thank-you thank-you-final'}>
          <div className={'thank-you__content'}>
            <div className="thank-you__top">
              <h1 className={'thank-you--title'}>
                La firma è andata a buon fine!
                <br />
                La richiesta di finanziamento per la tua {product.marca}{' '}
                {product.modello} è partita!
              </h1>
              <p className={'thank-you--intro'}>
                Entro 2 giorni ti contatteremo per aggiornarti sullo stato di
                lavorazione della tua richiesta.
                <br />
                Grazie per aver scelto un'auto brumbrum!
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ThanksFirma.propTypes = {
  product: PropTypes.object,
  customer: PropTypes.object,
  phaseChange: PropTypes.func,
  reroute: PropTypes.func,
  storeDumpItForce: PropTypes.func,
}

const mapStateToProps = state => ({
  product: state.product,
  customer: state.customer,
})

const mapDispatchToProps = dispatch => ({
  phaseChange: payload => dispatch(phaseChange(payload)),
  reroute: payload => dispatch(reroute(payload)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ThanksFirma)
